import { Switch, useMantineColorScheme } from '@mantine/core'
import { IconSun, IconMoon } from '@tabler/icons-react'
import { useEffect, useState } from 'react'

export function ThemeSwitcher() {
    const { colorScheme, toggleColorScheme } = useMantineColorScheme()
    const [isDark, setIsDark] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    useEffect(() => {
        // When colorScheme is 'auto', we need to check the actual computed color scheme
        if (colorScheme === 'auto') {
            // Check if the user's system prefers dark mode
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
            setIsDark(prefersDark)
        } else {
            setIsDark(colorScheme === 'dark')
        }
    }, [colorScheme])

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <Switch
            checked={isDark}
            onChange={toggleColorScheme}
            size={isMobile ? "lg" : "xl"}
            color="blue"
            thumbIcon={
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {isDark ? (
                        <IconMoon size={isMobile ? 12 : 16} color="#228be6" />
                    ) : (
                        <IconSun size={isMobile ? 12 : 16} color="#ffd43b" />
                    )}
                </div>
            }
            styles={{
                track: {
                    backgroundColor: isDark ? '#1a1b1e' : '#f8f9fa',
                    borderColor: isDark ? '#555' : '#ccc',
                    border: '2px solid',
                },
                thumb: {
                    backgroundColor: isDark ? '#25262b' : '#ffffff',
                    borderColor: isDark ? '#373a40' : '#dee2e6',
                    boxShadow: isDark
                        ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                        : '0 2px 8px rgba(0, 0, 0, 0.1)',
                },
            }}
        />
    )
} 